import React, { useEffect, useState } from "react";
import InputWrapper from "../../pages/citizen/AVPForms/layout/inputWrapper";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../pages/citizen/AVPForms/components/Button";
import { questions } from "./constant";
import { Button, Table } from "react-bootstrap";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import LowRiskDisclaimer from "./LowRiskDisclaimer";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";
import CheckBox from "../../../../templates/ApplicationDetails/components/EmpReusableComp/CheckBox";

const LandUseNOC = ({
  formData,
  role,
  handleTabChange,
  setOfficerNocDetails,
  setCurrentTab,
  setIsNoNoc,
  setMapSubNocDetails,
  handleNoWorkflowNoc,
}) => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const nocDocuments = formData?.documents?.filter((doc) => doc.isNoc === "true");
  console.log("formDataFromNOC", formData, nocDocuments, role);
  const getDocumentUrl = async (key) => {
    const currentDocId = nocDocuments?.filter((doc) => doc.documentType === key)[0]?.fileStoreId;
    const docUrl = await getDocumentByFileStoreId(currentDocId, setIsPreviewLoading);
    console.log("docUrlFromNew", docUrl);

    // window.open(docUrl, "_blank");
  };
  // const [checked, setChecked] = useState(false);
  // const handleChangeCheckBox = (event) => {
  //   setChecked(event.target.checked);
  // };
  const isLowRiskCase = formData?.riskType === "LOW";
  // formData?.descriptionOfLand.schemeType === "Scheme" &&
  // formData?.descriptionOfLand?.landUsesType === "Residential" &&
  // formData?.descriptionOfLand?.subLandUseAsPerLayout === "Residential" &&
  // formData?.descriptionOfLand?.landArea <= 2000;
  const Modal = useModal();
  const isEmployee = role === "EMPLOYEE";
  const isCitizen = role === "CITIZEN";
  const isViewCitizen = role === "VIEW_CITIZEN";
  const isApprovedCitizen = role === "APPROVED_CITIZEN";
  const isMapSubEmployee = role === "MAP_SUB_EMPLOYEE";
  const isMapSubEmployeeSelect = role === "MAP_SUB_EMPLOYEE_SELECT";
  const storedData = JSON.parse(sessionStorage.getItem("landUseNocData"));
  const defaultValues = {
    ...(storedData?.nocDetails || { ...formData?.nocDetails?.applicantNOCData }),
  };
  const { control, setValue, getValues, handleSubmit } = useForm({ defaultValues });
  const [additionalInputs, setAdditionalInputs] = useState([{ value: "" }]);
  const [showNocInput, setShowNocInput] = useState(false);
  const [showMapSubInput, setMapSubInput] = useState(false);
  const [additionalOfficerInputs, setAdditionalOfficerInputs] = useState([]);
  const [showOfficerNocInput, setShowOfficerNocInput] = useState(false);
  const [checked, setChecked] = React.useState(false);

  const nocDetails = formData?.nocDetails?.applicantNOCData;
  const officerNocData = formData?.nocDetails?.officerNOCData;
  const additionalApplicantNOC = formData?.nocDetails?.additionalApplicantNOC;
  const additionalOfficerNOC = formData?.nocDetails?.additionalOfficerNOC;
  const checkedByOfficer = formData?.nocDetails?.checkedByOfficer;
  const nocApplicantData = formData?.nocDetails?.applicantNOCData;
  const additionalNOC = formData?.nocDetails?.additionalApplicantNOC;
  const declarationMessage2 = "I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete.";
  console.log({ nocDetails, officerNocData, additionalApplicantNOC, additionalOfficerNOC, checkedByOfficer, nocApplicantData, additionalNOC });

  const getQuestionName = (role, question) => {
    return isEmployee || isMapSubEmployeeSelect ? question.employeeName : question.applicantName;
  };

  const handleCheckboxChange = (name, value) => {
    const updatedValues = { ...getValues(), [name]: value };
    console.log("checkBocChangedCalled", updatedValues);
    sessionStorage.setItem(
      "landUseNocData",
      JSON.stringify({
        nocDetails: updatedValues,
        nocDetailsApplicant: additionalInputs,
        nocDetailsOfficer: additionalOfficerInputs,
      })
    );
  };
  const handleAddInput = () => {
    setShowNocInput(true);
  };
  const handleAddOfficerInput = () => {
    setShowOfficerNocInput(true);
  };
  const handleChangeCheckBox = (event) => {
    setChecked(event.target.checked);
    // console.log("valueofcheck", event.target.checked);
  };
  const handleRemoveNoc = (index) => {
    const updatedInputs = additionalInputs.filter((_, i) => i !== index);
    setAdditionalInputs(updatedInputs);
    sessionStorage.setItem(
      "landUseNocData",
      JSON.stringify({
        nocDetails: getValues(),
        nocDetailsApplicant: updatedInputs,
        nocDetailsOfficer: additionalOfficerInputs,
      })
    );
  };
  const handleRemoveOfficerNoc = (index) => {
    const updatedInputs = additionalOfficerInputs.filter((_, i) => i !== index);
    setAdditionalOfficerInputs(updatedInputs);
    sessionStorage.setItem(
      "landUseNocData",
      JSON.stringify({
        nocDetails: getValues(),
        nocDetailsApplicant: additionalInputs,
        nocDetailsOfficer: updatedInputs,
      })
    );
  };

  const handleSaveNoc = () => {
    const newNoc = getValues("additional-noc");
    if (newNoc.trim()) {
      const updatedNocs = [...additionalInputs, { value: newNoc }];
      setAdditionalInputs(updatedNocs);
      setValue("additional-noc", "");
      setShowNocInput(false);
      sessionStorage.setItem(
        "landUseNocData",
        JSON.stringify({
          nocDetails: getValues(),
          nocDetailsApplicant: updatedNocs,
          nocDetailsOfficer: additionalOfficerInputs,
        })
      );
    }
  };
  const handleSaveOfficerNoc = () => {
    const newOfficerNoc = getValues("additional-officer-noc");
    if (newOfficerNoc.trim()) {
      const updatedOfficerNocs = [...additionalOfficerInputs, { value: newOfficerNoc }];
      setAdditionalOfficerInputs(updatedOfficerNocs);
      setValue("additional-officer-noc", "");
      setShowOfficerNocInput(false);
      sessionStorage.setItem(
        "landUseNocData",
        JSON.stringify({
          nocDetails: getValues(),
          nocDetailsApplicant: additionalInputs,
          nocDetailsOfficer: updatedOfficerNocs,
        })
      );
    }
  };
  const handleSaveMapSubOfficerNoc = () => {
    const newOfficerNoc = getValues("additional-officer-noc");
    if (newOfficerNoc.trim()) {
      const updatedOfficerNocs = [...additionalOfficerInputs, { value: newOfficerNoc }];
      setAdditionalOfficerInputs(updatedOfficerNocs);
      setValue("additional-officer-noc", "");
      setMapSubInput(false);
      sessionStorage.setItem(
        "landUseNocData",
        JSON.stringify({
          nocDetails: getValues(),
          nocDetailsApplicant: additionalInputs,
          nocDetailsOfficer: updatedOfficerNocs,
        })
      );
    }
  };
  const handleAddMapSubNoc = () => {
    setMapSubInput(true);
  };
  const getCheckedValues = () => {
    const checkedValues = [];

    formData?.nocDetails?.additionalApplicantNOC?.forEach((item, index) => {
      const checkedValue = getValues(`officer-input-${index}`);
      if (checkedValue) {
        checkedValues.push({ value: item.value });
      }
    });
    return checkedValues;
  };
  const onSubmit = (data) => {
    console.log("dataFromLandUSeSubmit", data);

    if (isCitizen) {
      const isNoNOC = !Object.keys(data).some((key) => data[key] == true);
      const isAddedNoc = additionalInputs?.length > 0 || additionalOfficerInputs?.length > 0;

      if (isNoNOC && !isAddedNoc) {
        Modal("NOC required", "Please select at least one NOC.", "error");
        return;
      }
      sessionStorage.setItem("landUseNocData", JSON.stringify(data)); // Save form data before moving to next tab
      data = {
        ...formData,
        nocDetails: { applicantNOCData: { ...data }, additionalApplicantNOC: additionalInputs },
      };
      console.log("dataFromEMplyee", data);

      handleTabChange(1, data);
    } else if (isMapSubEmployeeSelect) {
      const extraNoc = Object.keys(data).filter((key) => key.endsWith("Employee") && data[key] === true);
      setMapSubNocDetails((prev) => {
        return { ...prev, mapSubOfficerNoc: extraNoc, mapSubAdditionalOfficerNoc: additionalOfficerInputs };
      });
      console.log(" ", extraNoc, additionalOfficerInputs);
    } else {
      const isNoNOC = !Object.keys(data).some((key) => key.endsWith("Employee") && data[key] === true);
      const isAddedNoc = additionalInputs?.length > 0 || additionalOfficerInputs?.length > 0;
      console.log("LandUseNoc", isNoNOC, isAddedNoc, data);

      if (isNoNOC && !isAddedNoc) {
        Modal("NOC required", "Please select at least one NOC.", "error");
        setIsNoNoc(true);
        return;
      }
      setIsNoNoc(false);
      sessionStorage.setItem("landUseNocData", JSON.stringify(data)); // Save form data before moving to next tab
      console.log("valuesCheckedByofficer", getCheckedValues());
      // data = {
      //   ...formData,
      //   nocDetails: data,
      //   nocDetailsOfficer: additionalOfficerInputs,
      // };
      const checkedValues = getCheckedValues();
      console.log("dataFromEMplyee", data);
      setOfficerNocDetails((prev) => {
        return { ...prev, additionalOfficerNOC: additionalOfficerInputs, checkedByOfficer: checkedValues, officerNOCData: data };
      });
      handleNoWorkflowNoc({
        ...formData?.nocDetails,
        additionalOfficerNOC: additionalOfficerInputs,
        checkedByOfficer: checkedValues,
        officerNOCData: data,
      });
      Modal("Checklist saved", "Checklist details are saved.", "success");
      setCurrentTab(0);
    }
  };
  useEffect(() => {
    const savedNocs = storedData?.nocDetailsApplicant || formData?.nocDetailsApplicant || [];
    setAdditionalInputs(savedNocs);

    const savedOfficerNocs = storedData?.nocDetailsOfficer || formData?.nocDetailsOfficer || [];
    setAdditionalOfficerInputs(savedOfficerNocs);
  }, []);
  if (isLowRiskCase) {
    return <LowRiskDisclaimer handleTabChange={handleTabChange} tab={1} />;
  }
  if (isViewCitizen && !(Boolean(nocDetails) || Boolean(additionalApplicantNOC))) {
    return <div>Please fill NOC details.</div>;
  }
  return (
    <div className="groupContainer2">
      <form className="formContainer" onSubmit={handleSubmit(onSubmit)}>
        {isEmployee && (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "10px",
              borderRadius: "5px",
              color: "#333",
              marginBottom: "15px",
              fontWeight: "bold",
            }}
          >
            <p>
              <strong>Please note:</strong> The NOCs selected by the officer will be considered the final required NOCs for approval. Make sure to
              review the list carefully.
            </p>
          </div>
        )}
        <Table bordered hover responsive className="formHeaderContainer" onChange={handleCheckboxChange}>
          <thead style={{ backgroundColor: "rgb(21, 124, 179)", color: "white" }}>
            <tr>
              <th style={{ minWidth: "fit-content", padding: "4px" }}>NOC Checklist</th>
              {isCitizen && <th style={{ minWidth: "fit-content", padding: "4px" }}>Please tick, if required</th>}
              {(isApprovedCitizen || isViewCitizen) && <th style={{ minWidth: "fit-content", padding: "4px" }}>Your Inputs</th>}
              {isEmployee && <th style={{ minWidth: "fit-content", padding: "4px" }}>Applicant Inputs</th>}
              {isMapSubEmployeeSelect && <th style={{ minWidth: "fit-content", padding: "4px" }}>NOC Attached</th>}
              {(isEmployee || isApprovedCitizen || isMapSubEmployee || isMapSubEmployeeSelect) && (
                <th style={{ minWidth: "fit-content", padding: "4px" }}>Officer Input</th>
              )}
              {isMapSubEmployee && <th style={{ minWidth: "fit-content", padding: "4px" }}>File</th>}
            </tr>
          </thead>
          <tbody>
            {questions.map((question, index) => (
              <tr key={index}>
                {isMapSubEmployee && officerNocData?.[question.employeeName] && (
                  <React.Fragment>
                    <tr>
                      <td style={{ padding: "4px 4px 4px 8px" }}>{question.label}</td>
                    </tr>
                    <td style={{ textAlign: "center", padding: "4px" }}> {"Yes"} </td>
                    <td style={{ padding: "4px 4px 4px 8px" }}>
                      {" "}
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "20px", cursor: "pointer" }}
                        onClick={() => getDocumentUrl(question?.applicantName)}
                      />
                    </td>
                  </React.Fragment>
                )}
                {!isMapSubEmployee && !isViewCitizen && <td style={{ padding: "4px 4px 4px 8px" }}>{question.label}</td>}
                {isMapSubEmployeeSelect &&
                  (officerNocData?.[question.employeeName] ? (
                    <td style={{ textAlign: "center", padding: "4px" }}> {"Yes"} </td>
                  ) : (
                    <td style={{ textAlign: "center", padding: "4px" }}> {"No"} </td>
                  ))}
                {isMapSubEmployeeSelect &&
                  (officerNocData?.[question.employeeName] ? (
                    <td style={{ textAlign: "center", padding: "4px" }}> {"-"} </td>
                  ) : (
                    <td style={{ textAlign: "center", padding: "4px" }}>
                      <InputWrapper
                        type="checkbox"
                        name={getQuestionName(role, question)}
                        control={control}
                        containerStyles={{ padding: "0px", margin: "0" }}
                      />
                    </td>
                  ))}
                {isCitizen ? (
                  <td style={{ textAlign: "center", padding: "4px" }}>
                    <InputWrapper
                      type="checkbox"
                      name={getQuestionName(role, question)}
                      control={control}
                      containerStyles={{ padding: "0px", margin: "0" }}
                    />
                  </td>
                ) : isEmployee ? (
                  <td style={{ textAlign: "center", padding: "4px" }}>{nocDetails?.[question?.applicantName] ? "Yes" : "No"}</td>
                ) : isApprovedCitizen ? (
                  <td style={{ textAlign: "center", padding: "4px" }}>{nocDetails?.[question?.applicantName] ? "Yes" : "No"}</td>
                ) : null}

                {isApprovedCitizen && (
                  <td style={{ textAlign: "center", padding: "4px" }}> {officerNocData?.[question.employeeName] ? "Yes" : "No"} </td>
                )}

                {isEmployee && (
                  <td style={{ textAlign: "center", padding: "4px" }}>
                    <InputWrapper
                      type="checkbox"
                      name={`${getQuestionName(role, question)}`}
                      control={control}
                      containerStyles={{ padding: "0px", margin: "0" }}
                    />
                  </td>
                )}
              </tr>
            ))}
            {isViewCitizen && (
              <React.Fragment>
                {questions
                  .filter((questionItem) => nocApplicantData?.[questionItem.applicantName] === true)
                  .map((questionItem, index) => {
                    const { label, applicantName } = questionItem;
                    const answer = nocApplicantData?.[applicantName] ? "Yes" : "No";

                    return (
                      <tr key={`q-${index}`}>
                        <td style={{ width: "70%", textAlign: "left", padding: "8px" }}>{label}</td>
                        <td style={{ width: "30%", textAlign: "center", padding: "8px" }}>{answer}</td>
                      </tr>
                    );
                  })}

                {additionalNOC?.map((item, index) => (
                  <tr key={`a-${index}`}>
                    <td style={{ width: "70%", textAlign: "left", padding: "8px" }}>{item.value}</td>
                    <td style={{ width: "30%", textAlign: "center", padding: "8px" }}>Yes</td>
                  </tr>
                ))}
              </React.Fragment>
            )}
            {isApprovedCitizen &&
              additionalApplicantNOC?.map((item, index) => {
                return (
                  <tr>
                    <td style={{ padding: "4px 4px 4px 8px" }}>{item.value}</td>
                    <td style={{ textAlign: "center", padding: "4px" }}>Yes</td>
                    <td style={{ textAlign: "center", padding: "4px" }}>
                      {checkedByOfficer?.some((checkedItem) => checkedItem.value === item.value) ? "Yes" : "No"}
                    </td>
                  </tr>
                );
              })}
            {isApprovedCitizen &&
              additionalOfficerNOC?.map((item) => {
                return (
                  <tr>
                    <td style={{ padding: "4px 4px 4px 8px" }}>{item.value}</td>
                    <td style={{ textAlign: "center", padding: "4px" }}>No</td>
                    <td style={{ textAlign: "center", padding: "4px" }}>Yes</td>
                  </tr>
                );
              })}
            {isEmployee &&
              formData?.nocDetails?.additionalApplicantNOC?.map((item, index) => (
                <tr>
                  <td style={{ padding: "4px 4px 4px 8px" }}>{item.value}</td>
                  <td style={{ textAlign: "center", padding: "4px" }}>Yes</td>
                  <td style={{ textAlign: "center", padding: "4px" }}>
                    <InputWrapper
                      type="checkbox"
                      name={`officer-input-${index}`}
                      control={control}
                      containerStyles={{ padding: "0px", margin: "0" }}
                    />
                  </td>
                </tr>
              ))}

            {/* Render additional NOCs for Applicant */}
            {isCitizen &&
              additionalInputs?.length > 0 &&
              additionalInputs?.map((input, index) => (
                <tr key={`additional-${index}`}>
                  <td>{input.value}</td>
                  <td style={{ textAlign: "center" }}>
                    <Button variant="danger" size="sm" onClick={() => handleRemoveNoc(index)} style={{ backgroundColor: "rgb(255, 0, 0)" }}>
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              ))}

            {/* Render additional NOCs for Officer (if role is EMPLOYEE) */}
            {isEmployee &&
              additionalOfficerInputs?.length > 0 &&
              additionalOfficerInputs.map((input, index) => (
                <tr key={`officer-additional-${index}`}>
                  <td>{input.value}</td>
                  <td style={{ textAlign: "center" }} colSpan={2}>
                    <Button variant="danger" size="sm" onClick={() => handleRemoveOfficerNoc(index)} style={{ backgroundColor: "rgb(255, 0, 0)" }}>
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              ))}
            {isMapSubEmployeeSelect &&
              additionalOfficerInputs?.length > 0 &&
              additionalOfficerInputs.map((input, index) => (
                <tr key={`officer-additional-${index}`}>
                  <td>{input.value}</td>
                  <td style={{ textAlign: "center" }} colSpan={2}>
                    <Button variant="danger" size="sm" onClick={() => handleRemoveOfficerNoc(index)} style={{ backgroundColor: "rgb(255, 0, 0)" }}>
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              ))}

            {showNocInput && (
              <tr>
                <td>
                  <InputWrapper type="textInput" placeholder="Enter new NOC" control={control} name={"additional-noc"} hasLabel={false} />
                </td>
                <td style={{ textAlign: "center" }}>
                  <Button variant="success" size="sm" onClick={handleSaveNoc} style={{ backgroundColor: "rgb(21, 124, 179)" }}>
                    Save NOC
                  </Button>
                </td>
              </tr>
            )}
            {showMapSubInput && (
              <tr>
                <td>
                  <InputWrapper type="textInput" placeholder="Enter new NOC" control={control} name={"additional-officer-noc"} hasLabel={false} />
                </td>
                <td style={{ textAlign: "center" }} colSpan={2}>
                  <Button variant="success" size="sm" onClick={handleSaveMapSubOfficerNoc} style={{ backgroundColor: "rgb(21, 124, 179)" }}>
                    Save NOC
                  </Button>
                </td>
              </tr>
            )}

            {isEmployee && showOfficerNocInput && (
              <tr>
                <td>
                  <InputWrapper type="textInput" placeholder="Enter NOC details" control={control} name={"additional-officer-noc"} hasLabel={false} />
                </td>
                <td style={{ textAlign: "center" }} colSpan={2}>
                  <Button variant="success" size="sm" onClick={handleSaveOfficerNoc} style={{ backgroundColor: "rgb(21, 124, 179)" }}>
                    Save NOC
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {!isCitizen && !isViewCitizen && !isApprovedCitizen && !isMapSubEmployee && (
          <CheckBox handleChangeCheckBox={handleChangeCheckBox} declarationMessage={declarationMessage2} checked={checked} />
        )}
        {!isApprovedCitizen && !isMapSubEmployee && !isViewCitizen && (
          <div style={{ float: "right" }}>
            <Button
              variant="contained"
              color="success"
              size="medium"
              style={{ backgroundColor: "rgb(21, 124, 179)", borderRadius: "24px", marginRight: "36px" }}
              onClick={isEmployee ? handleAddOfficerInput : isMapSubEmployeeSelect ? handleAddMapSubNoc : handleAddInput}
            >
              <span style={{ color: "white" }}>
                <AddIcon />
                Add More
              </span>
            </Button>
          </div>
        )}
        {!isApprovedCitizen &&
          !isMapSubEmployee &&
          !isViewCitizen &&
          (!isEmployee || (isEmployee && checked)) &&
          (!isMapSubEmployeeSelect || (isMapSubEmployeeSelect && checked)) && (
            <div className="footerContainer2">
              <div className="buttonWrapper">
                {isCitizen && (
                  <ButtonWrapper variant="contained" color="error" size="medium" label="Prev" sx={{ backgroundColor: "#CCC", marginRight: "4px" }} />
                )}
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
                />
              </div>
            </div>
          )}
      </form>
    </div>
  );
};

export default LandUseNOC;
